import React, { useEffect, useState } from 'react';
import { Translation, getI18n } from 'react-i18next';
import { Form, Select, Divider, Typography } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import notification from '../../../elements/lib/NotificationWrapper';
import LearningAdminModuleCategoryModal from '../containers/LearningAdminModuleCategoryModalContainer';

const { Text } = Typography;

const ModuleCategoryInputRow = ({
  name,
  fieldKey = null,
  disabled = false,
  partnershipId,
  load,
  options,
  form,
  index,
  ...props
}) => {
  const [inputValue, setInputValue] = useState('');
  const [localOptions, setLocalOptions] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (partnershipId) {
      load(partnershipId);
    }
  }, [load, partnershipId]);

  useEffect(() => {
    setLocalOptions((prev) => {
      const newOnes = options.filter(
        (opt) => !prev.some((p) => p.id === opt.id)
      );
      return [...prev, ...newOnes];
    });
  }, [options]);

  const handleAddOption = (newValue) => {
    props.create(
      { name: newValue, partnership_id: partnershipId },
      (success, id) => {
        if (success) {
          const newOption = { id, name: newValue };

          setLocalOptions((prev) => [...prev, newOption]);

          const current = form.getFieldValue(name || 'categories_ids') || [];

          const updatedValues = [...current, id];

          form.setFields([
            {
              name: ['modules', index, 'categories_ids'],
              value: updatedValues,
            },
          ]);

          setSelected(updatedValues);

          notification.success(
            getI18n().t('learning_admin_form_module_category_created_success')
          );
          setInputValue('');
        } else {
          notification.error(
            getI18n().t('learning_admin_form_module_category_created_error')
          );
        }
      }
    );
  };

  const handleModal = () => {
    setVisible(true);
  };

  const handleSave = (values) => {
    form.setFields([
      {
        name: name,
        value: values,
      },
    ]);
  };

  return (
    <Translation>
      {(t) => (
        <>
          <div className='form-group'>
            <Form.Item noStyle name={name || 'categories_ids'}>
              <Select
                mode='multiple'
                showSearch
                disabled={props.isLoading || props.isSubmitting || disabled}
                loading={props.isLoading}
                showArrow
                allowClear
                style={{ width: '100%' }}
                onSearch={setInputValue}
                onChange={(values, optionObjects) => {
                  setSelected(values);
                }}
                dropdownRender={(menu) => (
                  <>
                    {menu}
                    {inputValue &&
                      !localOptions
                        .filter((x) => x.id !== undefined)
                        .some(
                          (opt) =>
                            opt.name.toLowerCase() === inputValue.toLowerCase()
                        ) && (
                        <>
                          <Divider style={{ margin: '8px 0' }} />
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              padding: '6px',
                              cursor: 'pointer',
                            }}
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => handleAddOption(inputValue)}
                          >
                            <PlusOutlined
                              style={{ marginRight: 8, color: '#729fe3' }}
                            />
                            <Text type='primary'>Add "{inputValue}"</Text>
                          </div>
                        </>
                      )}
                    <>
                      <Divider style={{ margin: '8px 0' }} />
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          marginLeft: '10px',
                          cursor: 'pointer',
                        }}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={() => handleModal()}
                      >
                        <Text type='primary' style={{ color: '#729fe3' }}>
                          {t('learning_admin_form_module_category_modal_title')}
                        </Text>
                      </div>
                    </>
                  </>
                )}
                filterOption={(input, option) =>
                  option.children.toLowerCase().includes(input.toLowerCase())
                }
                tokenSeparators={[',']}
                {...props}
              >
                {localOptions.map((x) => (
                  <Select.Option key={x.id} value={x.id}>
                    {x.name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </div>
          <LearningAdminModuleCategoryModal
            visible={visible}
            setVisible={setVisible}
            selected={selected}
            setSelected={setSelected}
            localOptions={localOptions}
            setLocalOptions={setLocalOptions}
            handleSave={handleSave}
          />
        </>
      )}
    </Translation>
  );
};

export default ModuleCategoryInputRow;
